import { useFormikContext } from 'formik'
import _ from "lodash";

function UseFormikHelper() {

    const { values, setFieldValue, setFieldTouched } = useFormikContext();

    const defaultValueFromOtherField = (filedName, defaultFieldName) => {
        setFieldValue(filedName, _.get(values,defaultFieldName));
        setFieldTouched(filedName, false);
    }

    const clearFieldValue = (filedName, defaultValue) => {
        setFieldValue(filedName, defaultValue)
        setFieldTouched(filedName, false);
    }

    const setTouched=(filedName,touchedValue)=>{
        setFieldTouched(filedName, touchedValue, false);
    }
    const setValue = (filedName, value) => {
        setFieldValue(filedName,value,false);
        setFieldTouched(filedName, false);
    }

    return {
        "defaultValueFromOtherField": defaultValueFromOtherField,
        "clearFieldValue": clearFieldValue,
        "setTouched" :setTouched,
        "setValue" : setValue
    }
}

export default UseFormikHelper